export const buildUrl = (path, params = {}) => {
    const url = Object.entries(params).reduce((result, [key, value]) => result.replace(`:${key}`, value), path);
    return `/${url}`;
};
